module.exports = __webpack_public_path__ + "static/media/our-philosophy.387b7123.jpg";